
import Vue from 'vue'
import ModalOverlay from '@/components/ModalOverlay.vue'
import { getRegion, custaRegions, Region } from '@/utils/common'

export default Vue.extend({
  name: 'RegionFlag',
  components: {
    ModalOverlay
  },
  data(): {
    showModal: boolean
  } {
    return {
      showModal: false
    }
  },
  computed: {
    regionFlag(): string | undefined {
      return getRegion()?.flag
    },
    regions():Region[] {
      return custaRegions
    }
  },
  methods: {
    toggleModal(state: boolean) {
      this.showModal = state
    },
    changeRegion(region: string, url: string) {
      if (region !== getRegion()?.region) {
        window.location.href = url
      }
      this.toggleModal(false)
    }
  }
})
